// Configurable list of Organization sub-features that become read-only once
// Aoikumo is connected. Keys are arbitrary; values map 1:1 to route names in
// organization/organization.routes.js and organization/constants/organization.js.
export const AOIKUMO_READ_ONLY_FEATURES = {
  BRANCHES: 'organization.branches',
  SERVICES: 'organization.services',
  STAFFS: 'organization.staffs',
  CONDITIONS: 'organization.conditions',
  PROMOTIONS: 'organization.promotions',
  STAFF_CALENDAR: 'organization.staff-calendar',
  // Not a real route — Rooms is a tab on branch details, gated by this key
  // via the same isReadOnlyRoute getter (a plain string-key lookup).
  ROOMS: 'organization.branches.rooms',
};

// Which of the above are gated once Aoikumo is connected AND at least one
// branch is linked to an outlet. Only data copied from Aoikumo is read-only;
// Staff Calendar, Conditions and Promotions are managed here. Branches are
// gated per branch (read-only once linked), not for the whole page. The Rooms
// tab is shown whenever Aoikumo is connected (see BranchDetails).
export const AOIKUMO_ACTIVE_READ_ONLY_FEATURES = [
  AOIKUMO_READ_ONLY_FEATURES.SERVICES,
  AOIKUMO_READ_ONLY_FEATURES.STAFFS,
];
